t = require('views/internal/teacup-with-helpers')('open-card-tip')
View = require 'view'

template = t.renderable ->
  t.div '.open-card-tip', ->
    t.div '.tip-text', ->
      t.format 'want-to-add-more-details-click-on-any-card-to-open-it'
    t.div '.tip-button.js-dismiss-open-card-tip', =>
      t.format 'got-it'

module.exports = class OpenCardTipView extends View
  render: ->
    @$el.html(template({}))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/open-card-tip-view.coffee